import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, ViewChild } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';
import { CommonService } from '../../../../../../common/services/Common.service';
import { EmailService } from '../../../../../../common/services/Email.service';
import { BsModalService } from 'ngx-bootstrap';
import { FieldService } from '../../../../../../common/services/Field.service';
import { UploadService } from '../../../../../../common/services/Upload.service';
import {
  ExpertField,
  Field,
  FieldType,
  FieldTypeLabel,
  TemplateConst,
  TemplateType,
  TicketField,
  UserField,
} from './template.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { SocialService } from '../../../../../../common/services/Social.service';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { CoreTemplateService } from '../../../../../../common/services/CoreTemplate.service';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { Observable } from 'rxjs';

declare var $: any;

@Component({
  selector: 'settings-other-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css'],
  providers: [CommonService, EmailService, BsModalService, FieldService, SocialService, CoreTemplateService],
})
@Injectable()
export class TemplateComponent extends BaseListComponent {
  @ViewChild('templateTemplate') template_template: ElementRef;

  public modelTemplate: any = {};
  public tab = 'template';

  public list: any = [];
  public listAccount: any = [];
  public source = 'all';
  public id_delete: number;
  public files: any = [];
  public allOaZalo: any = [];
  public allSmsBrandNames: any = [];
  public allEmails: any = [];
  public allTemplateZns: any = [];
  public lstTemplateZns: any = [];
  public allTemplate: any = [];
  public allType: any = [];
  public typeTemplate: any = [{ id: '', text: '' }];
  public fields: Field[] = [];
  public userFields: Field[] = [];
  public ticketFields: Field[] = [];
  public expertFields: Field[] = [];
  public list_page_devide: any = [];
  public groupedFieldsArray: (Field & { disabled?: boolean })[] = [];
  public mapKeyArray: any = [];
  public typeLabels = FieldTypeLabel;
  protected readonly TemplateType = TemplateType;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private fieldService: FieldService,
    private uploadService: UploadService,
    private emailService: EmailService,
    private commonService: CommonService,
    private socialService: SocialService,
    private coreTemplateService: CoreTemplateService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = TemplateConst.displayColumns();
    this.typeTemplate = TemplateConst.typeTemplate();
    this.userFields = UserField;
    this.ticketFields = TicketField;
    this.expertFields = ExpertField;
  }

  ngOnInit() {
    Observable.forkJoin([
      this.fieldService.allField(),
      this.socialService.listPageV2({ type: 0 }),
      this.socialService.listSms(),
      this.emailService.listAccount({}),
    ]).subscribe(data => {
      this.loadField(data[0]);
      this.loadZaloOa(data[1]);
      this.loadZmsBrandName(data[2]);
      this.loadEmailFrom(data[3]);
      this.loadData();
    });
  }

  loadField(res) {
    this.fields = [];
    if (res.status == 200) {
      const userKeys = [];
      const ticketKeys = [];
      res.data.forEach(e => {
        if (e.target == FieldType.User) {
          userKeys.push({
            id: FieldType.User + ':' + e.key,
            text: e.title,
            type: FieldType.User,
          });
        } else if (e.target == FieldType.Ticket) {
          ticketKeys.push({
            id: FieldType.Ticket + ':' + e.key,
            text: e.title,
            type: FieldType.Ticket,
          });
        }
      });
      this.userFields = [...this.userFields, ...userKeys];
      this.ticketFields = [...this.ticketFields, ...ticketKeys];
    }
    this.groupItems();
  }

  loadZaloOa(res) {
    if (res.status == 200 && !res.error) {
      this.allOaZalo = [{ id: '', text: 'Chọn' }];
      res.data.list.forEach(item => {
        this.allOaZalo.push({
          id: item.page_id,
          text: item.page_name,
        });
      });
    } else {
      this.allOaZalo = [{ id: '', text: 'Chọn' }];
    }
  }

  loadZmsBrandName(res) {
    if (res.status == 200 && !res.error) {
      this.allSmsBrandNames = [{ id: '', text: 'Chọn' }];
      res.data.list.forEach(item => {
        this.allSmsBrandNames.push({
          id: item.brand_name,
          text: item.brand_name,
        });
      });
    } else {
      this.allSmsBrandNames = [{ id: '', text: 'Chọn' }];
    }
  }
  loadEmailFrom(res) {
    if (res.status == 200 && !res.error) {
      this.allEmails = [{ id: '', text: 'Chọn' }];
      res.data.list.forEach(item => {
        this.allEmails.push({
          id: item.EMAIL_ADDRESS,
          text: item.EMAIL_ADDRESS,
        });
      });
    } else {
      this.allEmails = [{ id: '', text: 'Chọn' }];
    }
  }

  groupItems(): void {
    this.fields = [...this.userFields, ...this.ticketFields, ...this.expertFields];
    const groupedItems = this.fields.reduce((acc: { [key: number]: Field[] }, item: Field) => {
      if (!acc[item.type]) {
        acc[item.type] = [];
      }
      acc[item.type].push(item);
      return acc;
    }, {});
    this.groupedFieldsArray = [];
    for (const type in groupedItems) {
      if (groupedItems.hasOwnProperty(type)) {
        this.groupedFieldsArray.push({
          id: null,
          text: this.typeLabels[type],
          type: type,
          disabled: true,
        });
        this.groupedFieldsArray.push(...groupedItems[type]);
      }
    }
  }

  changeTemplateZns(value) {
    this.model['template_id'] = value;
    const template = this.lstTemplateZns.find(template => template.template_id === value);
    if (template) {
      this.model['template_content'] = template.content;
      this.mapKeyArray = [];
      template.key.forEach(item => {
        this.mapKeyArray = [...this.mapKeyArray, { key: item, value: '' }];
      });
    }
  }

  async loadZnsTemplateByOa(oa) {
    this.socialService.getZnsTemplateByOa(oa).subscribe(async res => {
      if (res.status == 200 && res.error == false) {
        this.allTemplateZns = [];
        this.lstTemplateZns = res.data;
        this.lstTemplateZns.forEach(item => {
          this.allTemplateZns.push({
            id: item.template_id,
            text: item.name,
          });
        });
        await this.setUpTemplateModal();
      } else {
        this.allTemplateZns = [];
      }
    });
  }

  async changeOaId(value) {
    await this.loadZnsTemplateByOa(value);
    this.mapKeyArray = [];
    this.model['oa_id'] = value;
    this.model['template_id'] = '';
    this.model['template_content'] = '';
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.coreTemplateService.list(this.source, payload).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data.data;
        this.data = this.data.map(r => {
          r.display_type = TemplateConst.templateTypeString(r.type);
          return r;
        });
        this.initPage(res.data.total);
      }
    });
  }

  setUpTemplateModal() {
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal == 'edit' ? 'Cập nhật biểu mẫu' : 'Tạo mới biểu mẫu',
      submit_title: this.typeModal == 'edit' ? 'Cập nhật' : 'Thêm mới',
    };
    this.modelDisplay = [
      {
        key: 'template_name',
        label: 'Tên biểu mẫu',
        type: FormFieldType.Text,
        value: this.model.template_name,
        required: true,
        disabled: false,
        blockEventChanged: true,
        width: 'full',
        order: 0,
      },
      {
        key: 'type',
        label: 'Loại biểu mẫu',
        type: FormFieldType.Select2,
        value: this.model.type,
        required: true,
        disabled: this.typeModal == 'edit',
        width: 'full',
        order: 1,
        options: { data: this.typeTemplate },
      },
    ];
    if (this.model.type == TemplateType.Zns.toString()) {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'oa_id',
          label: 'Zalo OA',
          type: FormFieldType.Select2,
          value: this.model.oa_id,
          required: true,
          disabled: false,
          width: '1/2',
          order: 2,
          options: { data: this.allOaZalo },
        },
        {
          key: 'template_id',
          label: 'Kịch bản ZNS',
          type: FormFieldType.Select2,
          value: this.model.template_id,
          required: true,
          disabled: false,
          width: '1/2',
          order: 3,
          options: { data: this.allTemplateZns },
        },
      ];
    } else if (this.model.type == TemplateType.Sms.toString()) {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'brand_name',
          label: 'Brandname',
          type: FormFieldType.Select2,
          value: this.model.brand_name,
          required: true,
          disabled: false,
          width: 'full',
          order: 4,
          options: { data: this.allSmsBrandNames },
        },
      ];
    }
    this.modelDisplay = [
      ...this.modelDisplay,
      {
        key: 'note',
        label: 'Mô tả',
        type: FormFieldType.Textarea,
        value: this.model.note,
        required: false,
        disabled: false,
        width: 'full',
        order: 5,
        options: { class: 'mh-50' },
      },
    ];

    if (this.model.type == TemplateType.Email.toString()) {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'email_from',
          label: 'Email gửi tin',
          type: FormFieldType.Select2,
          value: this.model.email_from,
          required: true,
          disabled: false,
          width: 'full',
          order: 6,
          options: { data: this.allEmails },
        },
        {
          key: 'template_subject',
          label: 'Tiêu đề',
          type: FormFieldType.Text,
          value: this.model.template_subject,
          required: true,
          disabled: false,
          condition: [
            {
              key: 'type',
              condition: '=',
              value: TemplateType.Email.toString(),
            },
          ],
          width: 'full',
          order: 6,
        },
      ];
    }

    this.modelDisplay = [
      ...this.modelDisplay,
      {
        key: 'template_content',
        label: 'Nội dung',
        type: this.model.type == TemplateType.Email.toString() ? FormFieldType.TextEditor : FormFieldType.Textarea,
        value: this.model.template_content,
        required: true,
        condition: !!this.model.type,
        disabled: this.model.type == TemplateType.Zns.toString(),
        width: 'full',
        order: 7,
        options: { class: 'mh-150' },
      },
      {
        key: 'attach_file',
        label: '',
        type: FormFieldType.FileAttach,
        value: this.model.attach_file,
        required: false,
        disabled: false,
        width: 'full',
        order: 8,
      },
    ];
    if (this.model.template_content && this.mapKeyArray.length > 0) {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'title_map_key',
          label: 'Gán giá trị cho biến',
          type: '',
          value: '',
          required: false,
          disabled: false,
          width: 'full',
          order: 9,
        },
      ];
    }
    let order = this.modelDisplay.length;
    for (const item of this.mapKeyArray) {
      order++;
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'key:' + item.key,
          label: item.key,
          type: FormFieldType.Select,
          value: item.value,
          required: false,
          disabled: false,
          condition: this.model.template_content
            ? [
                {
                  key: 'type',
                  condition: '=',
                  value: TemplateType.Zns.toString(),
                },
                {
                  key: 'type',
                  condition: '=',
                  value: TemplateType.Sms.toString(),
                },
              ]
            : false,
          width: 'full',
          order: order,
          options: { data: this.groupedFieldsArray },
        },
      ];
    }
  }

  async openModalTemplate(template: ElementRef, item?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    this.model = {
      template_name: '',
      attach_file: '',
      type: '',
      oa_id: '',
      template_id: '',
      note: '',
      template_subject: '',
      template_content: '',
      brand_name: '',
      key_object: {},
    };
    this.typeModal = item ? 'edit' : 'add';
    this.files = [];
    this.mapKeyArray = [];
    if (item) {
      this.model = {
        id: item.id,
        attach_file: item.attach_file,
        type: item.type.toString(),
        oa_id: item.oa_id,
        template_id: item.template_id,
        note: item.note,
        template_name: item.template_name,
        template_subject: item.template_subject,
        template_content: item.template_content,
        brand_name: item.brand_name,
        key_object: item.key_object ? JSON.parse(item.key_object) : item.key_object,
        attributes: item.attributes ? JSON.parse(item.attributes) : item.attributes,
      };
      if (!_.isEmpty(this.model.key_object)) {
        for (const key_object in this.model.key_object) {
          this.mapKeyArray.push({
            key: key_object,
            value: this.model.key_object[key_object],
          });
        }
      }
      if (this.model.oa_id) {
        await this.loadZnsTemplateByOa(this.model.oa_id);
      }
      this.model.attach_file = this.model.attach_file ? this.model.attach_file : '';
      if (this.model.attach_file) {
        this.files = this.model.attach_file.split(',');
      } else {
        this.files = [];
      }
      console.log(this.model);
      await this.setUpTemplateModal();
      setTimeout(() => {
        this.modalRef = this.modalService.show(template, config);
      }, 100);
    } else {
      await this.setUpTemplateModal();
      setTimeout(() => {
        this.modalRef = this.modalService.show(template, config);
      }, 100);
    }
  }

  async addTemplate(payload) {
    this.coreTemplateService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async editTemplate(id, payload) {
    this.coreTemplateService.update(id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  changeFile($event) {
    const files = $event.srcElement.files;
    const fileSize = files[0] ? files[0].size : 0;
    if (fileSize > 5242880) {
      this.toastr.error('Lỗi, dung lượng file vượt quá 5Mb', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      this.uploadService.upload(files[0]).then((res: any) => {
        if (!res.error) {
          this.files.push(this.commonService.file(res.data));
          this.model['attach_file'] = this.files.join(',');
          $event.target.value = null;
        } else {
          this.toastr.error(res.data.message, 'Lỗi', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
    }
  }

  deleteFile(file) {
    this.files = _.pull(this.files, file);
    this.model['attach_file'] = this.files.join(',');
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.coreTemplateService.deleteMany({ ids: this.delete_ids }).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.lstChecked = [];
          this.throwSuccess('Xóa thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.throwError('Xóa không thành công!');
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async handleAction(type: any, item?: any) {
    switch (type) {
      case TableAction.add:
        await this.openModalTemplate(this.template_template);
        break;
      case TableAction.edit:
        await this.openModalTemplate(this.template_template, item);
        break;
      case TableAction.delete:
        this.delete_ids = [item.id];
        await this.openConfirmDelete();
        break;
      case TableAction.deleteAll:
        this.delete_ids = this.lstChecked;
        await this.openConfirmDelete();
        break;
    }
  }

  async handleSubmitTemplate(item?: any) {
    this.message = null;
    this.model = _.merge({}, this.model, item);
    const key_object = {};
    let err_key_object = false;
    this.mapKeyArray.forEach(item => {
      if (!item.value) {
        err_key_object = true;
      }
      key_object[item.key] = item.value;
    });
    if (err_key_object) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Vui lòng gán giá trị cho biến!',
      };
      setTimeout(() => {
        this.message = null;
      }, 3000); // Tắt thông báo sau 3 giây
      return;
    }
    const attributes = TemplateConst.buildAttributes(key_object);
    const payload = {
      template_name: this.model.template_name,
      template_content: this.model.template_content,
      type: this.model.type,
      template_subject: this.model.template_subject,
      note: this.model.note,
      attach_file: this.model.attach_file,
      oa_id: this.model.oa_id,
      template_id: this.model.template_id,
      email_from: this.model.email_from,
      brand_name: this.model.brand_name,
      key_object: JSON.stringify(key_object),
      attributes: JSON.stringify(attributes),
    };
    switch (this.typeModal) {
      case 'add':
        await this.addTemplate(payload);
        break;
      case 'edit':
        await this.editTemplate(this.model.id, payload);
        break;
    }
  }

  async onChangeValueModelTemplate(key: any, item: any) {
    this.model = _.merge({}, this.model, item);
    if (key == 'type') {
      this.model = {
        template_name: item.template_name,
        attach_file: '',
        type: item.type,
        oa_id: '',
        template_id: '',
        note: item.note,
        template_subject: '',
        template_content: item.template_content,
        key_object: {},
        attributes: {},
      };
      this.mapKeyArray = [];
    }
    if (key == 'oa_id') {
      await this.changeOaId(this.model.oa_id);
    }
    if (key == 'template_id') {
      await this.changeTemplateZns(this.model.template_id);
    }
    if (key == 'template_content' && item.type == TemplateType.Sms) {
      await this.changeSmsContent(this.model.template_content);
    }
    if (key.includes(':')) {
      delete this.model[key];
      const k = key.split(':');
      this.mapKeyArray.map(x => {
        if (x.key == k[1]) {
          x.value = item[key];
        }
        return x;
      });
    }
    await this.setUpTemplateModal();
  }

  async changeSmsContent(content) {
    this.mapKeyArray = [];
    const regex = /{{(.*?)}}/g;
    let match;
    while ((match = regex.exec(content)) !== null) {
      this.mapKeyArray.push({
        key: match[1],
        value: '',
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/other/template/template.component.ts